import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { API_PREFIX } from '../providers/api-prefix.provider';

@Injectable({ providedIn: 'root' })
export class EntraIdAuthRepository {
  constructor(
    @Inject(API_PREFIX) private apiPrefix: string,
    private http: HttpClient,
  ) {}

  checkToken(token: string): Promise<boolean> {
    return firstValueFrom(this.http.post<boolean>(this.apiPrefix + 'v1/checkToken', { tokenId: token }));
  }
}
